import { MA_MARKETPLACE_LIST_REQUEST } from "./constants";

export const maMarketplaceListRequest = () => {
  return {
    type: MA_MARKETPLACE_LIST_REQUEST,
  };
};
